import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import store from './store';

Vue.use(Router);

const router = new Router({
  // Class automatically applied if the route matches
  linkActiveClass: 'is-active',
  // This removes the hash-bang from the url (e.g. "/#/ROUTE" => "/ROUTE") and supports HTML5 route history.
  mode: 'history',
  // Now we define our routes
  routes: [
    // Ensure Home is available when we visit the app
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login')
    },
    {
      path: '/gl-export',
      name: 'gl-export',
      component: () => import('./views/GLExport'),
      meta: {
        requiresAuth: true
      }
    },
    // Catch any undefined routes, send to homepage. (TODO - convert to a 404 Component)
    {
      path: '*',
      redirect: '/'
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next(`/login?requested=${to.name}`);
  } else {
    next();
  }
});

export default router;
